/** Valeurs acceptées par l'API (User.civilite). */
const CIVILITE_API = new Set(['M', 'Mme', 'Monsieur', 'Madame']);

/** Valeur pour le select admin (M / Mme) à partir de la base ou du sexe. */
export function civiliteToFormSelectValue(civilite, sexe) {
  const v = String(civilite || '').trim();
  if (v === 'M' || v === 'Monsieur') return 'M';
  if (v === 'Mme' || v === 'Madame') return 'Mme';
  if (sexe === 'Homme') return 'M';
  if (sexe === 'Femme') return 'Mme';
  return '';
}

/** Normalise avant enregistrement (M / Mme). */
export function civiliteForApiSave(formValue) {
  const v = String(formValue || '').trim();
  if (v === 'M' || v === 'Monsieur') return 'M';
  if (v === 'Mme' || v === 'Madame') return 'Mme';
  return CIVILITE_API.has(v) ? v : v;
}
